import { render, staticRenderFns } from "./CollapsibleNotesField.vue?vue&type=template&id=6f2b1c26&scoped=true"
import script from "./CollapsibleNotesField.vue?vue&type=script&lang=js"
export * from "./CollapsibleNotesField.vue?vue&type=script&lang=js"
import style0 from "./CollapsibleNotesField.vue?vue&type=style&index=0&id=6f2b1c26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2b1c26",
  null
  
)

export default component.exports